import { Check } from "lucide-react";

const STATUSES = [
  { key: "NEW", label: "New", dateKey: "date_created" },
  { key: "AGENT", label: "Allocated", dateKey: "date_allocated" },
  { key: "SCHEDULED", label: "Scheduled", dateKey: "date_scheduled" },
  { key: "IN_TRANSIT", label: "In Transit", dateKey: "date_in_transit" },
  { key: "JHB_DEPOT", label: "JHB Depot", dateKey: "date_jhb_depot" },
  { key: "DELIVERED", label: "Delivered", dateKey: "date_delivered" },
  { key: "COMPLETED", label: "Completed", dateKey: "date_completed" },
];

const STATUS_ORDER = STATUSES.map(s => s.key);

function formatDate(dateStr) {
  if (!dateStr) return null;
  try {
    return new Date(dateStr).toLocaleDateString("en-ZA", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit"
    });
  } catch {
    return dateStr;
  }
}

export default function StatusTimeline({ jobCard }) {
  if (!jobCard) return null;
  const currentIdx = STATUS_ORDER.indexOf(jobCard.status);

  return (
    <div data-testid="status-timeline" className="flex items-start gap-0 overflow-x-auto pb-2">
      {STATUSES.map((s, i) => {
        const isCompleted = i <= currentIdx;
        const isCurrent = s.key === jobCard.status;
        const date = jobCard[s.dateKey];
        return (
          <div key={s.key} className="flex items-start flex-1 min-w-[90px]">
            <div className="flex flex-col items-center">
              <div
                className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all
                  ${isCurrent
                    ? "bg-teal-500 border-teal-500 text-white"
                    : isCompleted
                      ? "bg-emerald-500/20 border-emerald-500 text-emerald-400"
                      : "bg-slate-100 border-slate-300 text-slate-400"
                  }`}
              >
                {isCompleted && !isCurrent ? <Check size={12} /> : (i + 1)}
              </div>
              <p className={`mt-1.5 text-[10px] uppercase tracking-wider font-medium text-center
                ${isCurrent ? "text-teal-600" : isCompleted ? "text-slate-700" : "text-slate-400"}`}>
                {s.label}
              </p>
              {date && (
                <p className="text-[9px] text-slate-400 mt-0.5 text-center">{formatDate(date)}</p>
              )}
            </div>
            {i < STATUSES.length - 1 && (
              <div className={`flex-1 h-0.5 mt-3.5 mx-1 ${i < currentIdx ? "bg-emerald-500/40" : "bg-slate-100"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
